import types from './types';

export const setClientWidth = value => ({
    type: types.WIDTH_UPDATED,
    payload: value
});

export const setClientHeight = value => ({
    type: types.HEIGHT_UPDATED,
    payload: value
});

export const setWebviewOs = value => ({
    type: types.WEBVIEW_OS_UPDATED,
    payload: value
});

export const setClientOffsetTop = value => ({
    type: types.SET_CLIENT_OFFSET_TOP,
    payload: value,
});

export const setTabVisibility = value => ({
    type: types.SET_TAB_VISIBILITY,
    payload: value,
});
